/* import __COLOCATED_TEMPLATE__ from './composer-tip-close-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();